// DS: DEV10
import React from 'react';
import StatisticsBarItem from './StatisticsBarItem';
import s from './StatisticsBar.scss';
const StatisticsBar = ({ stats, className })=>/*#__PURE__*/ React.createElement("div", {
        className: className
    }, stats.map((stat)=>stat && /*#__PURE__*/ React.createElement(StatisticsBarItem, {
            key: stat.label,
            icon: stat.icon,
            label: stat.label,
            className: s['stat-item']
        })));
StatisticsBar.displayName = 'StatisticsBar';
export default StatisticsBar;

//# sourceMappingURL=StatisticsBar.js.map